import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import { fetchSponsorLogsByYear } from './utils/api';
import magmaIcon from './assets/images/magma.ico';

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const initialYear = new Date().getFullYear().toString();
    const previousYear = String(parseInt(initialYear, 10) - 1);

    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('🚀 App: Starting data load from API...');

        const currentYearData = await fetchSponsorLogsByYear(initialYear);
        if (!isMounted) return;

        const currentLogs = currentYearData.sponsorLogs || [];
        console.log('📊 App: Current year data loaded:', {
          dataLength: currentLogs.length,
          year: initialYear
        });

        if (currentLogs.length > 0) {
          setData(currentLogs);
          console.log('✅ App: Successfully loaded current year data');
        } else {
          setError('No data returned from API endpoint.');
          setData([]);
        }

        // Fetch previous year in the background to avoid blocking initial render
        fetchSponsorLogsByYear(previousYear)
          .then(previousYearData => {
            if (!isMounted) return;
            const previousLogs = previousYearData.sponsorLogs || [];
            if (previousLogs.length > 0) {
              setData(prev => {
                const safePrev = Array.isArray(prev) ? prev : [];
                return [...safePrev, ...previousLogs];
              });
              console.log('✅ App: Previous year data loaded in background');
            }
          })
          .catch(backgroundError => {
            console.warn('⚠️ App: Previous year background load failed:', backgroundError.message);
          });

      } catch (err) {
        console.error('❌ App: Failed to load data from API:', err.message);
        setError(`Failed to load data from API: ${err.message}. Please check API configuration.`);
        setData([]);
      } finally {
        if (isMounted) {
          setLoading(false);
          console.log('🏁 App: Data loading process completed');
        }
      }
    };
  
    loadData();
    return () => {
      isMounted = false;
    };
  }, []);

  // App render completed

  if (loading) {
    return (
      <div className="loading-container">
        <div className="magma-icon">
          <img src={magmaIcon} alt="Magma" className="magma-spinner" />
        </div>
        <p>Loading sponsor data...</p>
      </div>
    );
  }

  if (error && (!data || data.length === 0)) {
    return (
      <div className="error-container">
        <h2>Error Loading Data</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="App">
      <Dashboard data={data || []} />
    </div>
  );
}

export default App;
